import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalDialogState {
  isOpen: boolean;
  message: string | null;
  onConfirm?: (() => void) | null;
}

const initialState: GlobalDialogState = {
  isOpen: false,
  message: null,
  onConfirm: null,
};

const globalDialogSlice = createSlice({
  name: "globalDialog",
  initialState,
  reducers: {
    openGlobalDialog: (
      state,
      action: PayloadAction<{ message: string; onConfirm: () => void }>
    ) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.onConfirm = action.payload.onConfirm;
    },
    closeGlobalDialog: (state) => {
      state.isOpen = false;
      state.message = null;
      state.onConfirm = null;
    },
  },
});

export const { openGlobalDialog, closeGlobalDialog } = globalDialogSlice.actions;
export default globalDialogSlice.reducer;
